<template>
    <div>
        <ContainerMembershipStatus v-if="!!currentUser?.has_aaa_membership || subscription"></ContainerMembershipStatus>
        <ContainerMembershipCheckout v-else-if="product && !subscription"></ContainerMembershipCheckout>
        <LoadingSection :loading="true" :error="error" v-else></LoadingSection>
    </div>
</template>

<script setup>
const {$config} = useNuxtApp();
useSeo().buildHead({
    title: 'Membership | ' + $config.public.siteName,
    description: 'Subscribe to Andy Guitar for the full experience.',
    index: true,
});

await useLazyAsyncData('load', () => useStoreMembership().getMembership().then(() => true));
</script>

<script>
import { mapState, mapActions } from 'pinia';

export default {
    computed: {
        ...mapState(useStoreAuth, {
            currentUser: 'currentUser',
        }),
        ...mapState(useStoreMembership, {
            subscription: 'subscription',
            product: 'product',
            error: 'error',
        }),
    },
    methods: {
        ...mapActions(useStoreMembership, {
            getMembership: 'getMembership',
        }),
    },
    mounted () {
        return this.getMembership();
    },
};
</script>
